"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casale-litta": {
    "609d2c4a": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-castellazzi": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82d1464b": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-degli-alberi": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "653cb717": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-del-giuoco": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a02d3228": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-della-costa": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c945966": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-motta": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a509389a": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-palude": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "350b5142": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-piatte": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "effbc3ce": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "i-torrioni": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f25a349": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "m-o-balzora": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c97641dc": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "monte-carbonaro": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea9888f4": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "roccolo": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b169cd6d": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "roncescio": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69b2d3b2": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "skipSearch": false
    }],
    "tordera": [{
      "hkey": "cb93c134",
      "slug": "casale-litta",
      "name": "Casale Litta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;